export const environment = {
    state: "production",
    role: "PARENT",
    baseUrl: "https://malirang.com",
    host: "https://parents.malirang.com",
    developTestMode: false,
    kakao: {
        redirectUri: "https://parents.malirang.com/login/kakao",
        clientId: "64ce2d1814a9f83a1852379692446476",
        appKey: "73b403efebdc3b2bc75779b4b2875420",
    },
    naver: {
        redirectUri: "https://parents.malirang.com/login/naver",
        clientId: "y0hF29XTrPxqx53QjUY1",
        clientSecret: "SW3_y0Z9UK",
    },
    firebase: {
        apiKey: "AIzaSyDudw6SODQ3odVjLmHYMDroaPFtXeHYtds",
        authDomain: "malirang-95d03.firebaseapp.com",
        projectId: "malirang-95d03",
        storageBucket: "malirang-95d03.firebasestorage.app",
        messagingSenderId: "317709108989",
        appId: "1:317709108989:web:472bf0a3e3ff33e9b5e094",
        measurementId: "G-RCMM2WNFHL",
    },
    nhn: {
        objectStorageContainer: "assets",
    },
    toss: {
        widgetClientKey: "live_gck_kYG57Eba3GYe2M1yv9WlrpWDOxmA",
        // widgetClientKey: "test_gck_ALnQvDd2VJPL74gWqWja8Mj7X41m",
    },
    lpinspection: {
        url: "https://inspection.malirang.com",
    },
    iap: {
        ios: "appl_EPKZaayZnaSniBoAZRZcoVdnqpp",
        android: "goog_MoANgYMvSuESrGwZAxctnMfTPXt",
    },
};
